import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Input, Alert, Form } from "antd";
import { UI_COLORS } from "../config";

const { TextArea } = Input;

export default function AddKeyModal({ visible, onClose, createKey, onCreated }) {
  const [form] = Form.useForm();
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setNotification({ type: "", message: "" });
      setIsSubmitting(false);
    }
  }, [visible, form]);

  const handleFormSubmit = async (values) => {
    const { keyName, keyValue } = values;
    if (!keyName?.trim() || !createKey) return;
    setIsSubmitting(true);
    try {
      const result = await createKey(`key-${keyName.trim()}`, keyValue || "");
      if (result?.success) {
        setNotification({ type: "success", message: `Key "${keyName}" created successfully!` });
        form.resetFields();
        onCreated?.();
        setTimeout(() => setNotification({ type: "", message: "" }), 1500);
      } else {
        setNotification({ type: "error", message: `Error creating key: ${result?.error || "Unknown error"}` });
      }
    } catch (err) {
      setNotification({ type: "error", message: `Error creating key: ${err?.message || err}` });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={<h3 style={{ color: UI_COLORS.primary, margin: 0 }}>Add New Key</h3>}
      onCancel={onClose}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={onClose} type="default" disabled={isSubmitting}>
          Cancel
        </Button>,
        <Button
          key="create"
          type="primary"
          style={{ backgroundColor: UI_COLORS.primary, borderColor: UI_COLORS.primary }}
          onClick={() => form.submit()}
          loading={isSubmitting}
          disabled={isSubmitting || !createKey}
        >
          {isSubmitting ? "Creating..." : "Create Key"}
        </Button>,
      ]}
      centered
      destroyOnHidden
    >
      {notification.type && (
        <div style={{ marginBottom: 12 }}>
          <Alert message={notification.message} type={notification.type === "success" ? "success" : "error"} showIcon />
        </div>
      )}

      <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
        <Form.Item
          name="keyName"
          label={<span className="block text-sm font-medium text-gray-700">Key Name</span>}
          rules={[{ required: true, message: "Key Name is required" }]}
        >
          <Input placeholder="Enter key name" autoFocus />
        </Form.Item>

        <Form.Item name="keyValue" label={<span className="block text-sm font-medium text-gray-700">Key Value</span>}>
          <TextArea placeholder="Enter key value" rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

AddKeyModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  createKey: PropTypes.func,
  onCreated: PropTypes.func,
};